import { defineComponent } from "vue";
import BaseModal from "@/components/Shared/Modals/BaseModal/BaseModal.vue";
import ExampleTestImage from "@/assets/covid/example-test.png";

export default defineComponent({
  components: {
    BaseModal,
  },
  data() {
    return {
      isActive: false,
      exampleTestPath: ExampleTestImage,
    };
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs["base-modal"];
      el.toggleBaseModal(status);
    },
  },
});
